<template>
  <div class="collection-card-wrapper">
    <div class="collection-header">
      <div class="documents-thumbs">
        <div class="image-container" v-for="thumb in thumbs" :key="thumb.documentId">
          <img class="collection-thumb" :src="validUrl(thumb.pages[1].small)" alt="thumb" />
        </div>
      </div>
      <ActionsMenu :collection="collection" />
    </div>

    <h4 class="collection-title">{{ collection.collectionName }}</h4>

    <div class="collection-details">
      <span>{{ numberOfDocuments }}</span>
      <span class="bullet">•</span>
      <span>{{ formatUpdatedAt }}</span>
    </div>
  </div>
</template>

<script>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n/dist/vue-i18n';
import { calculatePassedTime } from '~/utils/date-utils';
import ActionsMenu from '~/components/conversation/collections/ActionsMenu';
import useCollections from '~/composables/useCollections';
import validateUrl from '~/utils/url';

export default {
  components: { ActionsMenu },
  props: {
    collection: {
      type: Object,
      default: () => {},
    },
    thumbs: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { setThumbsCollectionsView, isReadOnly } = useCollections();
    const formatUpdatedAt = computed(() => calculatePassedTime(props.collection.modifiedAt));
    const numberOfDocuments = computed(() => `${props.collection.documents.length}  ${t('collections.documents')}`);

    // need this in case we are in collection view breadcrumb, add/delete a document and need to retrieve the current thumbs again when we come back
    watch(
      () => props.collection && props.collection.documents.length,
      async () => {
        await setThumbsCollectionsView([props.collection], 5);
      },
      {},
    );

    const validUrl = (url) => (validateUrl(url) ? url : '');

    return {
      emit,
      formatUpdatedAt,
      isReadOnly,
      numberOfDocuments,
      validUrl,
    };
  },
};
</script>

<style scoped lang="scss">
.collection-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: $bb-neutral-0;
  border-radius: 8px;
  padding: $bb-spacing-2;

  .collection-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: $bb-spacing-1;

    .documents-thumbs {
      display: flex;
      gap: $bb-spacing-1;
      width: 100%;

      .image-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between; /* Aligns children (start, content, end) */
        border-radius: $bb-spacing-1;
        background-color: $bb-neutral-5;
        max-width: 64px;
        height: 54px;
        align-items: flex-start;
        gap: $bb-spacing-1;
        flex-grow: 1;

        img {
          max-width: 60px;
          max-height: 48px;
          align-self: center;
        }
      }
    }
  }

  .collection-title {
    @include bb-medium-text-styles('xs');
  }

  .collection-details {
    @include bb-regular-text-styles('xs');

    span {
      color: $bb-neutral-3;
      letter-spacing: 0.1px;
      font-size: 13px;
    }

    .bullet {
      margin: 0 $bb-spacing-1;
    }
  }
}
</style>
